<template>
  <div>
    <label v-html="label" />
    <input
      v-focus="autofocus"
      :value="value"
      :type="type"
      :placeholder="placeholder"
      :maxlength="maxlength"
      @input="$emit('input', $event.target.value)"
      @keyup.enter="$emit('enter')"
    >
  </div>
</template>

<script>
  export default {
    name: 'Input',
    props: {
      type: {
        type: String,
        default: 'text',
      },
      placeholder: {
        type: String,
        default: '',
      },
      label: {
        type: String,
        default: '',
      },
      value: {
        type: String,
        default: '',
      },
      maxlength: {
        type: [Number, String],
        default: null,
      },
      autofocus: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>


<style scoped lang="stylus">
  @require '~@/style/type'

  label
    @extend $type-small, $type-semibold
    color: #666

  input
    @extend $type-small
    margin-top: 6px
    background-color: #fff
    display: block
    width: 100%
    box-sizing: border-box
    outline: none
    height 40px
    appearance: none
    border: 1px solid #D9D9D9
    border-radius: 3px
    padding: 0 10px
</style>
